import { Injectable } from "@angular/core";
import { FieldSchema, PropertyValue, SectionSchema } from "@maslul/common-services";

@Injectable({ providedIn: 'root' })
export class SchemaService {

    //לא בתוך טבלה
    updateFielsSchema(sectionsSchema: SectionSchema[], fieldName: string, propertiesValueToUpdate: PropertyValue[]) {

        sectionsSchema.forEach((sectionSchema: SectionSchema) => {
            sectionSchema.fieldsSchema.forEach((fieldShchema: FieldSchema) => {
                if (fieldShchema.name === fieldName) {
                    propertiesValueToUpdate.forEach((prop: PropertyValue) => {
                        fieldShchema[prop.propertyName] = prop.value;
                    })
                }
            })
        });
    }
}